'use client';

import * as React from 'react';
import { FileUpload } from './file-upload';
import { useUploadMedia } from '@/lib/api/media';

const MIME_VIDEO = ['video/mp4', 'video/webm', 'video/ogg', 'video/quicktime'];
const VIDEO_ACCEPT = MIME_VIDEO.join(',');

interface VideoUploadProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type' | 'onInput'> {
  url: string | undefined | null;
  onVideoAvailable: (url: string) => void;
}

export const VideoUpload = ({
  url: originalUrl,
  onVideoAvailable,
  className,
  ...props
}: VideoUploadProps) => {
  const { mutate: uploadVideo, isPending, isError, error } = useUploadMedia();

  const handleFileSelect = (file: File) => {
    const formData = new FormData();
    formData.append('file', file);
    uploadVideo(formData, {
      onError: (error) => {
        console.error(error);
      },
      onSuccess: (data) => {
        onVideoAvailable(data.file.url);
      },
    });
  };

  return (
    <FileUpload
      accept={VIDEO_ACCEPT}
      isLoading={isPending}
      error={isError ? (error?.message || 'Failed to upload video') : null}
      loadingText="Uploading video..."
      onFileSelect={handleFileSelect}
      className={className}
      {...props}
    />
  );
};
